import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';

const OutsourcingPilar2 = props => (
    <section id="outsourcing-pilar-section2" className="my pt-5">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-2.title')}</h2>
            <p><Trans i18nKey="services:outsourcingPilar:section-2.text" components={{ br: <br /> }} /></p>
        </Container>
    </section>
);


export default OutsourcingPilar2;